module.exports = __webpack_public_path__ + "b65252d213c5ac855377b754089abe96.svg";